import { render, staticRenderFns } from "./rebrush.vue?vue&type=template&id=c930c6b6&scoped=true"
import script from "./rebrush.vue?vue&type=script&lang=js"
export * from "./rebrush.vue?vue&type=script&lang=js"
import style0 from "./rebrush.vue?vue&type=style&index=0&id=c930c6b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c930c6b6",
  null
  
)

export default component.exports